import { solicitar } from '../identidad/cliente-identidad.js'
export interface Correspondencia {
  id: string
  expedienteId: string | null
  clase: 'PROPIA' | 'INSTITUCIONAL'
  fecha: string
  titulo: string
  descripcion: string
  tipoDocumento: string
  visibilidad: string
  nombreOriginal: string
  mime: string
  tamano: number
}
export function listarCorrespondencia() {
  return solicitar<{ datos: Correspondencia[] }>('/api/v1/correspondencia')
}
export function crearCorrespondenciaPropia(
  expedienteId: string,
  datos: Record<string, string>,
  archivo: File,
) {
  const cuerpo = new FormData()
  Object.entries(datos).forEach(([clave, valor]) => cuerpo.append(clave, valor))
  cuerpo.append('archivo', archivo)
  return solicitar<{ id: string }>(`/api/v1/expedientes/${expedienteId}/correspondencia`, {
    method: 'POST',
    body: cuerpo,
  })
}
export function publicarCorrespondencia(datos: Record<string, string>, archivo: File) {
  const cuerpo = new FormData()
  Object.entries(datos).forEach(([clave, valor]) => cuerpo.append(clave, valor))
  cuerpo.append('archivo', archivo)
  return solicitar<{ id: string }>('/api/v1/correspondencia/institucional', {
    method: 'POST',
    body: cuerpo,
  })
}
